/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkOffIcon16Light = forwardRef('AttachLinkOffIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.354.646a.5.5 0 1 0-.708.708l12.5 12.5a.5.5 0 0 0 .708-.708l-1.697-1.696A4.5 4.5 0 0 0 11 3H9.5a.5.5 0 0 0 0 1H11a3.5 3.5 0 0 1 1.411 6.704L9.707 8H11.5a.5.5 0 0 0 0-1H8.707l-3-3H6.5a.5.5 0 0 0 0-1H5c-.095 0-.19.003-.284.009L2.354.646Z" }),
        React.createElement("path", { d: "M2.407 3.822A4.5 4.5 0 0 0 5 12h1.5a.5.5 0 0 0 0-1H5a3.5 3.5 0 0 1-1.872-6.458l-.72-.72Z" }),
        React.createElement("path", { d: "M5.586 7H4.5a.5.5 0 0 0 0 1h2.086l-1-1Z" })));
});
